import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/store/authStore';
import { useUsers } from './hooks/useUsers';
import { UserList } from './components/UserList';

export function Users() {
  const { 
    users, 
    handleAddUser, 
    handleUpdatePhone, 
    handleUpdatePassword,
    handleDeleteUser, 
    showAddDialog, 
    setShowAddDialog 
  } = useUsers();
  const currentUser = useAuthStore((state) => state.user);
  const isAdmin = currentUser?.role === 'admin';

  return (
    <div className="h-full flex flex-col">
      <div className="flex-shrink-0 flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">المستخدمين</h2>
        {isAdmin && (
          <Button
            onClick={() => setShowAddDialog(true)}
            className="hover:bg-secondary"
          >
            <Plus className="h-4 w-4 ml-2" />
            إضافة مستخدم
          </Button>
        )}
      </div>

      <div className="flex-1 overflow-y-auto">
        <UserList
          users={users || []}
          isAdmin={isAdmin}
          onAddUser={handleAddUser}
          onUpdatePhone={handleUpdatePhone}
          onUpdatePassword={handleUpdatePassword}
          onDelete={handleDeleteUser}
          showAddDialog={showAddDialog}
          setShowAddDialog={setShowAddDialog}
        />
      </div>
    </div>
  );
}